

export const matchDeeply = (...routes: string[]) => `${joinRoute(...routes)}/*`;
export const joinRoute = (...routes: string[]) => routes.join('/');
